document.addEventListener('click', (e) => {
  const link = e.target.closest('a[href*="#"]');
  if (!link) return;

  const url = new URL(link.href, window.location.origin);

  if (
    url.pathname !== window.location.pathname ||
    !url.hash ||
    url.hash === '#'
  ) {
    return;
  }

  const target = document.querySelector(url.hash);
  if (!target) return;

  e.preventDefault();

  const header = document.querySelector('header');
  let headerHeight = header ? header.offsetHeight : 0;
  
  let stickyBar = document.querySelector('#StickyScrollBar');
  if (stickyBar && window.screen.width >= 750){
    headerHeight += stickyBar.offsetHeight;
  }
  const targetPosition =
    target.getBoundingClientRect().top +
    window.pageYOffset -
    headerHeight;

  window.scrollTo({
    top: targetPosition,
    behavior: 'smooth'
  });

  history.pushState(null, '', url.hash);
});

class CollapsibleTabImg extends HTMLElement {
  connectedCallback() {
    this.addEventListener("click", (event) => {
      const question = event.target.closest(".question");
      if (!question) return;

      const item = question.closest("li");
      const answer = item.querySelector(".answer");
      const isOpen = item.classList.contains("open");

      this.querySelectorAll(".accordion-custom li").forEach((li) => {
        if (li !== item) {
          li.classList.remove("open");
          this.slideUp(li.querySelector(".answer"));
        }
      });

      if (isOpen) {
        item.classList.remove("open");
        this.slideUp(answer);
      } else {
        item.classList.add("open");
        this.slideDown(answer);
      }
    });
  }

  slideUp(element, duration = 300) {
    if (!element) return;

    element.style.height = `${element.scrollHeight}px`;
    element.style.overflow = "hidden";

    requestAnimationFrame(() => {
      element.style.transition = `height ${duration}ms ease`;
      element.style.height = "0";
    });

    setTimeout(() => {
      element.style.display = "none";
      element.style.removeProperty("height");
      element.style.removeProperty("overflow");
      element.style.removeProperty("transition");
    }, duration);
  }

  slideDown(element, duration = 300) {
    if (!element) return;

    element.style.display = "block";

    const height = element.scrollHeight;

    element.style.height = "0";
    element.style.overflow = "hidden";

    requestAnimationFrame(() => {
      element.style.transition = `height ${duration}ms ease`;
      element.style.height = `${height}px`;
    });

    setTimeout(() => {
      element.style.removeProperty("height");
      element.style.removeProperty("overflow");
      element.style.removeProperty("transition");
    }, duration);
  }
}

customElements.define("collapsible-tab-img", CollapsibleTabImg);

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.testimonial-section').forEach((section) => {
    const swiperEl = section.querySelector('.swiper');
    if (!swiperEl) return;

    const duration = parseInt(section.dataset.swiperDuration, 10) || 4000;

    swiperEl.style.setProperty('--swiper-duration', `${duration}ms`);

    const swiper = new Swiper(swiperEl, {
      loop: true,
      speed: 600,
      effect: 'slide',
      autoplay: {
        delay: duration,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      pagination: {
        el: section.querySelector('.swiper-pagination'),
        clickable: true,
      },
      on: {
        slideChangeTransitionStart() {
          section
            .querySelectorAll('.swiper-pagination-bullet')
            .forEach((bullet) => {
              void bullet.offsetWidth;
            });
        },
        autoplayPause() {
          section
            .querySelectorAll('.swiper-pagination-bullet-active')
            .forEach((bullet) => {
              bullet.classList.add('paused');
            });
        },
        autoplayResume() {
          section
            .querySelectorAll('.swiper-pagination-bullet-active')
            .forEach((bullet) => {
              bullet.classList.remove('paused');
            });
        },
      },
    });

    swiperEl.addEventListener('mouseenter', () => {
      section
        .querySelectorAll('.swiper-pagination-bullet-active')
        .forEach((bullet) => {
          bullet.classList.add('paused');
        });
    });

    swiperEl.addEventListener('mouseleave', () => {
      section
        .querySelectorAll('.swiper-pagination-bullet-active')
        .forEach((bullet) => {
          bullet.classList.remove('paused');
        });
    });
  });
});



class SubscriptionWidget extends HTMLElement {
  constructor() {
    super();
    const productBlock = this.querySelector('.custom-sub-widget');
    // const sellingPlanInput = document.createElement('input');
    // sellingPlanInput.type = 'hidden';
    // sellingPlanInput.name = 'selling_plan';
    // productBlock.appendChild(sellingPlanInput);

    const purchaseOptions = productBlock.querySelectorAll('.purchase-option');
    const subscribeOptionsWrap = productBlock.querySelector('.subscribe-options-wrap');
    const selectElement = productBlock.querySelector('.select__select');
    const subscribeRadio = productBlock.querySelector('#product-subscribe');
    const onetimeRadio = productBlock.querySelector('#product-onetime');

    let sealSubscribeRadio = null;
    let sealOnetimeRadio = null;
    let sealWidgetReady = false;
    let currentSelectedOption = 'subscribe';

    /* ------------------------------
       TOGGLE COMPARE PRICE
    ------------------------------ */

    function toggleComparePrice() {
      const comparePrices = document.querySelectorAll('.price-item--compare-at');

      comparePrices.forEach((price) => {
        if (currentSelectedOption === 'subscribe') {
          price.classList.remove('hidden');
        } else {
          price.classList.add('hidden');
        }
      });
    }

    /* ------------------------------
       OBSERVE SEAL SUBSCRIPTIONS
    ------------------------------ */

    function observeSealWidget() {
      const observer = new MutationObserver((mutations, obs) => {
        sealSubscribeRadio = document.querySelector('.sls-option-container:not(.sls-disabled-option-container) .sls-option[data-type="subscription"]');
        sealOnetimeRadio = document.querySelector('.sls-option[data-type="one_time"]');

        if (sealSubscribeRadio && sealOnetimeRadio) {
          sealWidgetReady = true;
          obs.disconnect();

          if (subscribeRadio.checked) {
            sealSubscribeRadio.click();
          } else if (onetimeRadio.checked) {
            sealOnetimeRadio.click();
          }
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });

      setTimeout(() => observer.disconnect(), 10000);
    }

    /* ------------------------------
       UPDATE SELLING PLAN
    ------------------------------ */

    function updateSellingPlan(event) {
      //sellingPlanInput.value = event.target.value;
      toggleComparePrice();
    }

    /* ------------------------------
       BUTTON DISPLAY
    ------------------------------ */

    function toggleButtonDisplay() {
      const buttonText = document.querySelector('.product-form__button--text');
      const buttonPrice = document.querySelector('.product-form__button--price');

      const stikcySelling = document.querySelector('.product-sticky-selling');
      const stickyRegular = document.querySelector('.product-sticky-regular');

      if (currentSelectedOption === 'subscribe') {
        if (buttonText) buttonText.classList.add('hidden');
        if (buttonPrice) buttonPrice.classList.remove('hidden');
        if (stikcySelling) stikcySelling.classList.remove('hidden');
        if (stickyRegular) stickyRegular.classList.add('hidden');
      } else {
        if (buttonText) buttonText.classList.remove('hidden');
        if (buttonPrice) buttonPrice.classList.add('hidden');
                if (stikcySelling) stikcySelling.classList.add('hidden');
        if (stickyRegular) stickyRegular.classList.remove('hidden');
      }
    }

    /* ------------------------------
       UPDATE TAB
    ------------------------------ */

    function updateTab(selectedOption) {
      currentSelectedOption = selectedOption;

      purchaseOptions.forEach(option => {
        const isSelected = option.dataset.purchaseoption === selectedOption;
        option.classList.toggle('selected', isSelected);
      });

      const contents = productBlock.querySelectorAll('.tab-content');
      contents.forEach(content => {
        content.style.display = content.dataset.content === selectedOption ? 'block' : 'none';
      });

      if (selectedOption === 'subscribe') {
        document.querySelector('product-info').classList.add('subscription-active');
        if(subscribeOptionsWrap) subscribeOptionsWrap.style.display = 'block';
        const selectedValue = selectElement?.value;
        //if (selectedValue) sellingPlanInput.value = selectedValue;
        subscribeRadio.checked = true;
        
        if (sealWidgetReady && sealSubscribeRadio && !sealSubscribeRadio.checked) {
          sealSubscribeRadio.click();
        }
      } else {
        document.querySelector('product-info').classList.remove('subscription-active');
        if(subscribeOptionsWrap) subscribeOptionsWrap.style.display = 'none';
        //sellingPlanInput.value = '';
        onetimeRadio.checked = true;

        if (sealWidgetReady && sealOnetimeRadio && !sealOnetimeRadio.checked) {
          sealOnetimeRadio.click();
        }
      }

      toggleButtonDisplay();
      toggleComparePrice();
    }

    /* ------------------------------
       PURCHASE OPTION CLICK
    ------------------------------ */

    purchaseOptions.forEach(option => {
      option.addEventListener('click', () => {
        const selected = option.dataset.purchaseoption;
        updateTab(selected);
      });
    });

    /* ------------------------------
       SELLING PLAN SELECT CHANGE
    ------------------------------ */

    if (selectElement) {
      selectElement.addEventListener('change', updateSellingPlan);
    }

    /* ------------------------------
       VARIANT CHANGE (DAWN FIX)
    ------------------------------ */

    const productForm = document.querySelector('product-form, form[action*="/cart/add"]');
    if (productForm) {
      productForm.addEventListener('change', (e) => {
        if (e.target.name === 'id') {
          setTimeout(() => {
            toggleButtonDisplay();
            toggleComparePrice();
          }, 50);
        }
      });
    }

    /* ------------------------------
       INITIAL STATE FROM URL
    ------------------------------ */

    const params = new URLSearchParams(window.location.search);
    const purchaseParam = params.get('purchase');

    const initialOption =
      purchaseParam === 'onetime' || purchaseParam === 'subscribe'
        ? purchaseParam
        : 'subscribe';

    updateTab(initialOption);

    /* ------------------------------
       START OBSERVER
    ------------------------------ */

    observeSealWidget();
  }
}

customElements.define('subscription-widget', SubscriptionWidget);


document.addEventListener('DOMContentLoaded', () => {
  if (window.Shopify?.routes?.root && !document.body.classList.contains('template-index')) return;

  const updateMainOffset = () => {
    const header = document.querySelector('sticky-header');
    const main = document.querySelector('main');

    if (header && main) {
      main.style.marginTop = `-${header.offsetHeight}px`;
    }
  };

  updateMainOffset();
  window.addEventListener('resize', updateMainOffset);
});


class StickyATC extends HTMLElement {
  constructor() {
    super();

    this.wrapper = this.querySelector('.sticky-atc-wrapper');
    this.productInfo = this.closest('product-info');
    this.productForm = this.productInfo?.querySelector('product-form');

    this.onScroll = this.onScroll.bind(this);
    this.onResize = this.onResize.bind(this);
    this.onClick = this.onClick.bind(this);
  }

  connectedCallback() {
    if (!this.wrapper || !this.productForm) return;

    this.updateHeaderHeight();

    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onResize);
    this.addEventListener('click', this.onClick);

    this.onScroll();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onResize);
    this.removeEventListener('click', this.onClick);
  }

  updateHeaderHeight() {
    const header = document.querySelector('sticky-header');
  }

  onResize() {
    this.updateHeaderHeight();
    this.onScroll();
  }

  onScroll() {
    const formRect = this.productForm.getBoundingClientRect();
    const footer = document.querySelector('.shopify-section-group-footer-group');
    const footerRect = footer?.getBoundingClientRect();

    // Form is above the visible area (taking sticky header into account)
    const formPastHeader = formRect.bottom <= 0;

    // Form is still below the viewport
    const formBelowViewport = formRect.top >= window.innerHeight;

    // Footer is visible
    const footerVisible =
      footerRect &&
      footerRect.top < window.innerHeight &&
      footerRect.bottom > 0;

    const shouldShow =
      formPastHeader &&
      !formBelowViewport &&
      !footerVisible;

    this.wrapper.classList.toggle('active', shouldShow);
  }

  onClick(e) {
    const button = e.target.closest('button.product-form__submit');
    if (!button || !this.contains(button)) return;

    button.setAttribute('aria-disabled', true);
    button.classList.add('loading');
    button.querySelector('.loading__spinner').classList.remove('hidden');
    // Your submit logic here if needed
  }
}

customElements.define('sticky-atc', StickyATC);